import { Chess, Move } from "chess.js";
import { aiMove } from "js-chess-engine";
import { CustomBoardConstants, DIFFICULTY } from "./constants";
import { Difficulty } from "../types/general";

/**
 * Makes a move for the AI.
 * If the AI has a promotion, it defaults to a queen promotion since it can't make a choice.
 * Could be cool to explore allowing it to make a choice.
 */
export async function getAIMove(fen: string, aiDifficulty: Difficulty): Promise<Move | null> {
    // Delay AI move for better UX
    await new Promise((r) => setTimeout(r, CustomBoardConstants.AI_RESPONSE_DELAY));
    const calculatedMove = aiMove(fen, DIFFICULTY.OPTIONS[aiDifficulty]);
    const [from, to] = Object.entries(calculatedMove)[0];

    const chess = new Chess(fen);
    const move = chess.move({ from: from.toLowerCase(), to: to.toLowerCase() });

    return move;
}
